import { render, staticRenderFns } from "./BackofficeUser.vue?vue&type=template&id=3ec6f3de&"
import script from "./BackofficeUser.vue?vue&type=script&lang=ts&"
export * from "./BackofficeUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports